import { CommonTagIconProps } from '../types';

const FastPace = ({ dimension }: CommonTagIconProps) => (
  <svg
    width={dimension || 20}
    height={dimension || 20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.88105 18.7249C4.62305 17.2959 3.87805 15.4329 3.87805 13.3979C3.87805 8.90988 7.51205 5.27588 12.0001 5.27588C16.4731 5.27588 20.1221 8.90988 20.1221 13.3979C20.1221 15.4319 19.3611 17.2809 18.1031 18.7089"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12 5.5V7.574"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M20.1221 13.5808H18.0481"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M6.01604 13.5808H3.94104"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M7.77804 9.32686L6.31104 7.85986"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M17.753 7.85986L16.286 9.32686"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13.16 14.6108L15.221 12.5498"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12 17.3299C12.8345 17.3299 13.511 16.6534 13.511 15.8189C13.511 14.9844 12.8345 14.3079 12 14.3079C11.1655 14.3079 10.489 14.9844 10.489 15.8189C10.489 16.6534 11.1655 17.3299 12 17.3299Z"
      stroke="#101828"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);
export default FastPace;
